export const APPLICATION_DB_EDITOR = "DB_EDITOR";
export const APPLICATION_PARTS_CATALOG = "PARTS_CATALOG";
/** ROLE_READ_ONLY */
export const ROLE_READ_ONLY = 1;
/** ROLE_WRITE_USER — update access in an application */
export const ROLE_WRITE_USER = 2;
/** ROLE_ADMIN */
export const ROLE_ADMIN = 3;

const SUPPORTED_APPLICATIONS = [APPLICATION_DB_EDITOR, APPLICATION_PARTS_CATALOG];

export function getApplicationLabel(applicationKey) {
  if (applicationKey === APPLICATION_DB_EDITOR) {
    return "DB Editor";
  }

  if (applicationKey === APPLICATION_PARTS_CATALOG) {
    return "Parts Catalog Editor";
  }

  return applicationKey;
}

export function getApplicationRoute(applicationKey) {
  if (applicationKey === APPLICATION_PARTS_CATALOG) {
    return "/parts-catalog-editor";
  }

  return "/home";
}

export function getAccessibleApplications(appRoleIds = {}) {
  return SUPPORTED_APPLICATIONS.filter((applicationKey) => {
    const roleIds = appRoleIds?.[applicationKey];
    return Array.isArray(roleIds) && roleIds.length > 0;
  });
}

export function canAccessApplication(appRoleIds = {}, applicationKey) {
  return getAccessibleApplications(appRoleIds).includes(applicationKey);
}

export function hasMultiApplicationAccess(appRoleIds = {}) {
  return getAccessibleApplications(appRoleIds).length > 1;
}

export function hasAdminRole(roleIds = []) {
  return Array.isArray(roleIds) && roleIds.includes(ROLE_ADMIN);
}

export function parseStoredRoleIds(value) {
  try {
    const parsed = JSON.parse(value || "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
}

export function parseStoredAppRoleIds(value) {
  try {
    const parsed = JSON.parse(value || "{}");
    return parsed && typeof parsed === "object" && !Array.isArray(parsed)
      ? parsed
      : {};
  } catch (error) {
    return {};
  }
}

export function hasDbEditorUpdateAccess(appRoleIds = {}, globalRoleIds = []) {
  if (Array.isArray(globalRoleIds) && globalRoleIds.includes(ROLE_ADMIN)) {
    return true;
  }
  const roles = appRoleIds?.[APPLICATION_DB_EDITOR];
  if (!Array.isArray(roles)) {
    return false;
  }
  return roles.includes(ROLE_WRITE_USER) || roles.includes(ROLE_ADMIN);
}

export function hasDbEditorUpdateAccessFromStorage() {
  return hasDbEditorUpdateAccess(
    parseStoredAppRoleIds(localStorage.getItem("appRoleIds")),
    parseStoredRoleIds(localStorage.getItem("roleId"))
  );
}

/** PARTS_CATALOG role 2 (write) or 3 (admin); role 1 is read-only. */
export function hasPartsCatalogUpdateAccess(appRoleIds = {}, globalRoleIds = []) {
  if (Array.isArray(globalRoleIds) && globalRoleIds.includes(ROLE_ADMIN)) {
    return true;
  }
  const roles = appRoleIds?.[APPLICATION_PARTS_CATALOG];
  if (!Array.isArray(roles)) {
    return false;
  }
  return roles.includes(ROLE_WRITE_USER) || roles.includes(ROLE_ADMIN);
}

export function hasPartsCatalogUpdateAccessFromStorage() {
  return hasPartsCatalogUpdateAccess(
    parseStoredAppRoleIds(localStorage.getItem("appRoleIds")),
    parseStoredRoleIds(localStorage.getItem("roleId"))
  );
}
